import { useParams } from "react-router-dom";

export const ThreeCardsSurveys = () => {
  const { id } = useParams();
  const path = '/newsletter/versions/three_cards_surveys.html';
  return (
    <iframe
      title={"Three Cards Surveys"}
      src={path}
      style={{ width: "100vw", height: "100vh" }}
    />
  );
};
